import _regeneratorRuntime from "/var/lib/jenkins/workspace/workspace/mr-learner-frontend-production/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/lib/jenkins/workspace/workspace/mr-learner-frontend-production/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import { getBytes, getLines, getMessages } from './parse';
export var EventStreamContentType = 'text/event-stream';
var DefaultRetryInterval = 1000;
var LastEventId = 'last-event-id';
export function fetchEventSource(input, _a) {
  var inputSignal = _a.signal,
      inputHeaders = _a.headers,
      inputOnOpen = _a.onopen,
      onmessage = _a.onmessage,
      onclose = _a.onclose,
      onerror = _a.onerror,
      openWhenHidden = _a.openWhenHidden,
      inputFetch = _a.fetch,
      rest = __rest(_a, ["signal", "headers", "onopen", "onmessage", "onclose", "onerror", "openWhenHidden", "fetch"]);

  return new Promise(function (resolve, reject) {
    var headers = Object.assign({}, inputHeaders);

    if (!headers.accept) {
      headers.accept = EventStreamContentType;
    }

    var curRequestController;

    function onVisibilityChange() {
      curRequestController.abort();

      if (!document.hidden) {
        create();
      }
    }

    if (!openWhenHidden) {
      document.addEventListener('visibilitychange', onVisibilityChange);
    }

    var retryInterval = DefaultRetryInterval;
    var retryTimer = 0;

    function dispose() {
      document.removeEventListener('visibilitychange', onVisibilityChange);
      window.clearTimeout(retryTimer);
      curRequestController.abort();
    }

    inputSignal === null || inputSignal === void 0 ? void 0 : inputSignal.addEventListener('abort', function () {
      dispose();
      resolve();
    });
    var fetch = inputFetch !== null && inputFetch !== void 0 ? inputFetch : window.fetch;
    var onopen = inputOnOpen !== null && inputOnOpen !== void 0 ? inputOnOpen : defaultOnOpen;

    function create() {
      return _create.apply(this, arguments);
    }

    function _create() {
      _create = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _a, response, interval;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                curRequestController = new AbortController();
                _context.prev = 1;
                _context.next = 4;
                return fetch(input, Object.assign(Object.assign({}, rest), {
                  headers: headers,
                  signal: curRequestController.signal
                }));

              case 4:
                response = _context.sent;
                _context.next = 7;
                return onopen(response);

              case 7:
                _context.next = 9;
                return getBytes(response.body, getLines(getMessages(function (id) {
                  if (id) {
                    headers[LastEventId] = id;
                  } else {
                    delete headers[LastEventId];
                  }
                }, function (retry) {
                  retryInterval = retry;
                }, onmessage)));

              case 9:
                onclose === null || onclose === void 0 ? void 0 : onclose();
                dispose();
                resolve();
                _context.next = 17;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](1);

                if (!curRequestController.signal.aborted) {
                  try {
                    interval = (_a = onerror === null || onerror === void 0 ? void 0 : onerror(_context.t0)) !== null && _a !== void 0 ? _a : retryInterval;
                    window.clearTimeout(retryTimer);
                    retryTimer = window.setTimeout(create, interval);
                  } catch (innerErr) {
                    dispose();
                    reject(innerErr);
                  }
                }

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 14]]);
      }));
      return _create.apply(this, arguments);
    }

    create();
  });
}

function defaultOnOpen(response) {
  var contentType = response.headers.get('content-type');

  if (!(contentType === null || contentType === void 0 ? void 0 : contentType.startsWith(EventStreamContentType))) {
    throw new Error("Expected content-type to be ".concat(EventStreamContentType, ", Actual: ").concat(contentType));
  }
}